import { useState, useCallback, useEffect } from 'react'
import { CUSTOMER_UNREAD_NOTIFICATIONS } from '@graphql'

interface UnreadNotifications {
  count: number
}

// Ensure userData type is compatible, using 'any' for flexibility as it's not strictly typed in Header
export const useNotifications = (userData: any) => {
  const [hasNotifications, setHasNotifications] =
    useState<UnreadNotifications>()

  const fetchNotifications = useCallback(async () => {
    if (!userData) return

    const apolloClient = await (
      await import('@/utils/apolloClient')
    ).initializeApollo()
    const { data } = await apolloClient.query({
      query: CUSTOMER_UNREAD_NOTIFICATIONS,
    })
    setHasNotifications(data.unreadNotifications)
  }, [userData])

  useEffect(() => {
    if (userData) fetchNotifications()
  }, [userData, fetchNotifications])

  const unreadApplications =
    userData?.type === 'Customer' ? !!hasNotifications?.count : false

  return {
    hasNotifications,
    unreadApplications,
    fetchNotifications,
  }
}
